import { render, staticRenderFns } from "./ContractInfoTab.vue?vue&type=template&id=27becca2&scoped=true&"
import script from "./ContractInfoTab.vue?vue&type=script&lang=js&"
export * from "./ContractInfoTab.vue?vue&type=script&lang=js&"
import style0 from "./ContractInfoTab.vue?vue&type=style&index=0&id=27becca2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27becca2",
  null
  
)

export default component.exports